export default __webpack_public_path__ + "static/made-okine-sans-light-outline-32a0966e507ce29a182c86513d85c5ec.woff2";